
import { dayjs } from '@umanforge/common';
import DatePickerSoloInput from './datePickerInputSolo.component';
import { useEffect, useState } from 'react';

interface DateSelectorProps {
  setCurrentDay: ( day: dayjs.Dayjs ) => void;
  currentDay: dayjs.Dayjs;
  isWeek?: boolean;
  areWeekEnd?: boolean;
}

const DateSelector = ( { setCurrentDay, currentDay, isWeek = true, areWeekEnd = false }: DateSelectorProps ) => {
  const [ displayDate, setDisplayDate ] = useState<dayjs.Dayjs>( currentDay );

  const handleChange = ( date: dayjs.Dayjs ) => {
    if ( isWeek ) {
      if ( date?.startOf( 'week' ).diff( currentDay, 'day' ) != 0 ) {
        setCurrentDay( date.startOf( 'week' ) );
      }
      setDisplayDate( currentDay.startOf( 'week' ) );
    }
    else {
      setCurrentDay( date );
      setDisplayDate( currentDay );
    }
  };

  const incrementDate = ( dir: 1 | -1 ) => {
    if ( isWeek ) {
      handleChange( currentDay.add( ( 7 * dir ), 'day' ) );
    }
    else {
      let tmpday = currentDay.add( dir, 'day' );
      if ( !areWeekEnd ) {
        while ( tmpday.day() === 0 || tmpday.day() === 6 ) {
          tmpday = tmpday.add( dir, 'day' );
        }
      }
      handleChange( tmpday );
    }
  };

  useEffect( () => {
    handleChange( currentDay );
  }, [ currentDay ] );

  return (
    <div className="mt-1 flex justify-center w-full">
      <ul className="flex items-center -space-x-px h-12 text-sm">
        <li>
          <button onClick={() => { return incrementDate( -1 ); }} className="flex items-center justify-center px-3 h-12 ms-0 leading-tight text-gray-500 bg-white border border-e-0 border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700">
            <span className="sr-only">Previous</span>
            <svg className="w-2.5 h-2.5 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 1 1 5l4 4" />
            </svg>
          </button>
        </li>
        <li>
          <div className="flex items-center justify-center w-72 h-12 leading-tight text-gray-500 bg-white border border-gray-300 hover:border-gray-400">
            <DatePickerSoloInput
              onChange={handleChange}
              defaultValue={ displayDate }
              isWeek={ isWeek }
              className='bg-white border border-solid outline-0 '
            />
          </div>
        </li>
        <li>
          <button onClick={() => { return incrementDate( 1 ); }} className="flex items-center justify-center px-3 h-12 leading-tight text-gray-500 bg-white border border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700">
            <span className="sr-only">Next</span>
            <svg className="w-2.5 h-2.5 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4" />
            </svg>
          </button>
        </li>
      </ul>
    </div>
  );
};

export default DateSelector;